import {connect} from "redux-vue";
import classNames from "classnames";
import * as userActions from "../actions/user";

const Nav = {
  props: ['sticky', 'user', 'logout'],

  data() {
    return {
      aside: false,
      menuLang: false,
      menuAccount: false,
      langAlert: false,
    }
  },

  mounted() {
    window.setTimeout(() => {
      this.langAlert = Number( localStorage.getItem('Nav/langAlert') || 1 );
      window.localStorage.setItem('Nav/langAlert', 0);
    }, 800);
  },

  methods: {
    toggleMenuLang() {
      this.closeLangAlert();
      this.menuLang = !this.menuLang;
    },

    toggleMenuAccount() {
      this.menuAccount = !this.menuAccount;
    },

    closeLangAlert() {
      this.langAlert = false;
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const navClass = classNames("bg-primary z-50" , { "sticky top-0": this.sticky });
    const isAuthorized = !!(this.user.token && this.user.model);

    return (
      <nav class="sticky top-0 z-50 w-screen bg-primary">
        <div class="z-10 relative">
          <div class="container mx-auto">
          <div class="absolute bg-secondary h-full hidden right-0 lg:block w-1/2 z-0"></div>
            <ul class={classNames("flex justify-between h-full z-10 relative text-white text-sm lg:text-lg", isAuthorized ? "" : "flex-wrap lg:flex-no-wrap")}>
              <li class={classNames("flex flex-wrap lg:flex-no-wrap mx-auto bg-primary justify-around items-center py-1 lg:mx-0", isAuthorized ? "w-5/6 lg:w-11/12 lg:mr-5" : "w-full lg:w-3/4 lg:mr-5")}>
                <router-link to={{name: 'HomePage'}}>
                  <img src={'/img/who-logo_euro-en-white.png'} alt="WHO regional office for Europe" class="h-12 lg:h-16 mr-10"/>
                </router-link>
                  <img src={'/img/ukrainian-public-health-ctr-logo-white.png'} alt="Ukrainian Public Heath Center" class="h-10 lg:h-12"/>
                  <h1 class="text-sm lg:text-xl text-center lg:text-left leading-tight font-bold px-5 lg:px-0 lg:ml-10 lg:mr-5 text-white">
                    {this.$t('nav.h1')}
                  </h1>
                
              </li>
              
              
             {isAuthorized && (
                <li class="lg:relative w-1/6 lg:w-1/12 text-center">
                  <button onClick={this.toggleMenuAccount} type="button" class={classNames(
                    "focus:outline-none h-full",
                    this.menuAccount ? 'text-white z-10 relative' : 'hover:text-blue-300'
                  )}>
                    <span class="flex items-center">
                      {Boolean(this.user.model.avatar) && (
                        <img src={process.env.VUE_APP_BASE + "/storage/" + this.user.model.avatar} alt="" class="lg:h-8 h-6 w-6 lg:w-8 rounded-full relative bg-secondary"/>
                      )}
                      {Boolean(this.user.model.avatar) || (
                        <i class="mdi mdi-account-circle text-2xl lg:text-3xl"></i>
                      )}
                      <i class="mdi mdi-chevron-down text-sm lg:text-base ml-px"></i>
                    </span>
                  </button>
                  {this.menuAccount && (
                    <div onClick={this.toggleMenuAccount} class="fixed top-0 bottom-0 left-0 right-0 bg-black opacity-50 lg:opacity-0"></div>
                  )}
                  <transition
                    name="custom-classes-transition"
                    enter-active-class="transition ease-out duration-100 transform"
                    enter-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75 transform"
                    leave-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                  >
                    {this.menuAccount && (
                      <div class="origin-top lg:origin-top-right absolute right-0 w-screen lg:w-64 lg:rounded-b-md shadow-lg">
                        <div class="bg-white lg:rounded-b-md shadow-xs text-lg text-gray-700 h-screen lg:h-auto">
                          <button onClick={this.toggleMenuAccount} type="button" class="p-3 focus:outline-none float-right lg:hidden">
                            <i class="mdi mdi-close text-3xl leading-none"></i>
                          </button>
                          <ul class="text-base py-5">
                            <li class="mb-4">
                              <router-link to={{name: 'ProfilePage'}} class="block px-8 flex items-center relative z-50">
                                <i class="mdi mdi-account-circle text-orange-600 mr-1 text-xl leading-none"></i>
                                {this.$t('my_profile')}
                              </router-link>
                            </li>
                            <li>
                              <div onClick={this.logout} class="cursor-pointer block px-8 flex items-center">
                                <i class="mdi mdi-logout-variant text-gray-400 mr-1 text-xl"></i>
                                {this.$t('sign_out')}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </transition>
                </li>
              )}
               
              {isAuthorized || (
                <li class="pb-2 lg:pb-0 flex-grow justify-around lg:justify-end w-1/2 lg:w-auto flex items-center lg:relative">
                  <router-link to={{name: 'RegisterModal'}} class="text-white hover:text-blue-300">
                    {this.$t('create_an_account')}
                  </router-link>
                </li>
              )}
              {isAuthorized || (
                <li class="items-center hidden lg:flex px-2 lg:relative">|</li>
              )}
              {isAuthorized || (
                <li class="pb-2 lg:pb-0 flex flex-grow justify-around w-1/2 lg:w-auto lg:justify-start items-center lg:relative">
                  <router-link to={{name: 'LoginModal'}} class="text-white hover:text-blue-300">
                    {this.$t('sign_in')}
                  </router-link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div class="w-full bg-accent">
        <div class="container mx-auto">
            <ul class="flex flex-wrap lg:flex-no-wrap lg:justify-start ml-4 h-full relative text-white text-sm lg:text-lg">
              
              <li class="flex justify-around text-center items-center h-8 lg:h-12">
                <router-link to={{name: 'CoursesPage'}} class="hover:underline mr-16">
                  {this.$t('courses')}
                </router-link>
                <router-link to={{name: 'HelpPage'}} class="hover:underline">
                  {this.$t('help_page.h1')}
                </router-link>
              </li>
              <li class={`items-center justify-around text-center flex-grow ${isAuthorized ? 'flex' : 'hidden lg:flex'}`}>
                
              </li>
            </ul>
          </div>
          </div>
      </nav>
      
    );

    return (
      <nav class={navClass}>
        <div class="overflow-hidden">
          <div class="container mx-auto px-6">
            <div class="flex">
              <div class="flex items-center py-3 lg:py-4 flex-1 md:relative">
                <button onClick={this.open} type="button" class="mr-6 absolute lg:relative focus:outline-none text-sm">
                  <i class="mdi mdi-menu text-3xl text-white"></i>
                </button>
                <router-link to={{name: 'HomePage'}} class="mx-auto lg:mx-0">
                  <span class="flex items-center">
                    <img src="/img/brand.png" alt="WHO regional office for Africa" class="h-10 lg:h-12"/>
                    <h1 class="text-xl font-bold ml-6 text-white hidden md:block">
                      {this.$t('nav.h1')}
                    </h1>
                  </span>
                </router-link>
                {isAuthorized && (
                  <button type="button" class="mr-6 absolute right-0 lg:relative focus:outline-none lg:hidden" onClick={this.logout}>
                    <i class="mdi mdi-logout-variant text-xl text-white"></i>
                  </button>
                )}
                {isAuthorized || (
                  <router-link to="/login" class="mr-6 absolute right-0 lg:relative focus:outline-none lg:hidden">
                    <i class="mdi mdi-login-variant text-xl text-white"></i>
                  </router-link>
                )}

              </div>

              <div class="pl-8 hidden lg:block relative">
                <div class="bg-accent absolute top-0 left-0 h-full w-screen"></div>
                <div class="flex items-center h-full z-10 relative">
                <div class="text-white mr-2">{this.$i18n.locale}</div>
                  {isAuthorized || (
                    <router-link to="/register" class="text-white text-sm font-bold">
                      {this.$t('create_an_account')}
                    </router-link>
                  )}
                  {isAuthorized && (
                    <router-link to="/profile" class="text-white text-sm">
                      {this.user.model.name}
                    </router-link>
                  )}
                  <span class="px-3 text-white">|</span>
                  {isAuthorized && (
                    <button type="button" class="text-white text-sm font-bold focus:outline-none" onClick={this.logout}>
                      {this.$t('sign_out')}
                    </button>
                  )}
                  {isAuthorized || (
                    <router-link to="/login" class="text-white text-sm font-bold">
                      {this.$t('log_in')}
                    </router-link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <aside class="bg-white fixed top-0 left-0 h-full w-full md:max-w-xs overflow-y-auto pb-6 transform -translate-x-full z-50">
          <div class="flex justify-end sticky top-0">
            <button onClick={this.close} type="button" class="p-3 focus:outline-none">
              <i class="mdi mdi-close text-3xl leading-none"></i>
            </button>
          </div>
          <ul class="border-b pb-10 text-base">
            <li class="mb-4">
              <router-link to="/courses" class="block px-8 lg:px-10">
                <i class="mdi mdi-school text-orange-600 mr-1 text-xl leading-none"></i>
                {this.$t('courses')}
              </router-link>
            </li>
            {isAuthorized && (
              <li class="mb-4 lg:mb-0">
                <router-link to="/profile" class="block px-8 lg:px-10">
                  <i class="mdi mdi-account-circle text-orange-600 mr-1 text-xl leading-none"></i>
                  {this.$t('my_profile')}
                </router-link>
              </li>
            )}
            {isAuthorized || (
              <li class="mb-4 lg:mb-0">
                <router-link to="/register" class="block px-8 lg:px-10">
                  <i class="mdi mdi-cursor-default-click-outline text-orange-600 mr-1 text-xl leading-none"></i>
                  {this.$t('create_an_account')}
                </router-link>
              </li>
            )}
          </ul>
          <ul class="py-8 text-base">
            <li class="mb-4">
              <router-link to="/help" class="block px-8 lg:px-10">
                <i class="mdi mdi-help-circle text-gray-400 mr-1 text-xl"></i>
                {this.$t('help_page.h1')}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link to="/contact" class="block px-8 lg:px-10">
                <i class="mdi mdi-email-variant text-gray-400 mr-1 text-xl"></i>
                {this.$t('contact_modal.h1')}
              </router-link>
            </li>
            {isAuthorized && (
              <li>
                <span onClick={this.logout} class="block px-8 lg:px-10 cursor-pointer">
                  <i class="mdi mdi-logout-variant text-gray-400 mr-1 text-xl"></i>
                  {this.$t('sign_out')}
                </span>
              </li>
            )}

            {isAuthorized || (
              <li>
                <router-link to={{name: 'LoginModal'}} class="block px-8 lg:px-10">
                  <i class="mdi mdi-logout-variant text-gray-400 mr-1 text-xl"></i>
                  {this.$t('sign_in')}
                </router-link>
              </li>
            )}
          </ul>
        </aside>
      </nav>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapActionToProps(dispatch) {
  return {
    logout: () => dispatch(userActions.logout()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(Nav);

